'use strict';
const RequestManager = require('../helpers/request-manager');
const ParamsManager = require('../helpers/params-manager');
const errorHandler = require('../helpers/error-handler');

class Billing {
  constructor(credentials, request, sdkConfiguration) {
    this.requestManager = new RequestManager(sdkConfiguration, request, credentials);
    this.paramsManager = new ParamsManager();
  }

  getAzureRateCard(currency, region) {
    this.requestManager.requestConfigurationManager.setApi('GetAzureRateCard');
    this.paramsManager.addQueryParam({ currency }, { region });
    return this.requestManager.makeRequest(this.paramsManager.getRequestParams())
      .catch(errorHandler.removeMicrosoftDetails);
  }

}

module.exports = Billing;
